exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-a8da9878],.fade-leave-active[data-v-a8da9878]{transition:opacity .3s}.fade-enter[data-v-a8da9878],.fade-leave-to[data-v-a8da9878]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a8da9878","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/CustomerRiskProfiling.vue
// module id = 133
// module chunks = 0